(ns net.kestec.mhda-pilgrimage.public.applications.applications-events
  (:require
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [ajax.core :as ajax]
    [day8.re-frame.http-fx]
    [re-frame.core :as rf]
    ))


(rf/reg-event-db
  ::set-show-new-application-popup
  (fn [db [_ show?]]
    (assoc db ::db/show-new-application-popup show?)))

(rf/reg-event-fx
  ::new-application-created
  (fn [_ _]
    {:dispatch-n [[::load-applications]
                  [::set-show-new-application-popup nil]]}))

(rf/reg-event-fx
  ::delete-application
  (fn [{db :db} [_ application-id]]
    {:http-xhrio {:method          :delete
                  :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id]) "/application/" application-id)
                  :format          (ajax/json-request-format)
                  :response-format (ajax/text-response-format)
                  :on-success      [::load-applications]
                  :on-failure      [::db/log-error ::delete-application]}}))

(rf/reg-event-fx
  ::create-new-application
  (fn [{db :db} [_ data]]
    {:http-xhrio {:method          :post
                  :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id]) "/application")
                  :format          (ajax/json-request-format)
                  :response-format (ajax/text-response-format)
                  :params          (assoc data
                                     :pilgrimage-id (get-in db [::db/me :pilgrimage-id])
                                     :applicant-id (get-in db [::db/me :applicant-id]))
                  :on-success      [::new-application-created]
                  :on-failure      [::db/log-error ::create-new-application]}}))

(rf/reg-event-fx
  ::load-applications
  (fn [{db :db} _]
    (println "load my applications")
    {:http-xhrio [{:method          :get
                   :uri             (str "/api/pilgrimage/" (get-in db [::db/me :pilgrimage-id]) "/my-applications")
                   :response-format (ajax/json-response-format {:keywords? true})
                   :on-success      [::db/set! ::db/my-applications]
                   :on-failure      [::db/log-error]}]}))